import React, { useState } from "react";
import { FormGroup, Button, Table, Input } from "reactstrap";
import ProvenirApi from "../../api/ProvenirApi";
import { useSideChannelSubscription } from "../../util/useSideChannel";
import Loader from "../Loader";
import Notification from "../Notification";

function EvaluateCreditCapacityField(props) {
    const {
        formContext,
        schema: { title },
        uiSchema: { "ui:readonly": readonly },
        formData,
        required,
        rawErrors,
        idSchema,
    } = props;

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const { sideChannel } = formContext;
    const formObject = useSideChannelSubscription(sideChannel, 1) || {};

    const {
        clasificacionScore,
        cumpleCapacidadPago,
        cumpleEdadPlazo,
        cumpleMora30d,
        cumpleMora60d,
        cumpleMora90d,
        decisionFinal,
        motivosRechazoIdentificador,
        motivosRechazoMensaje,
        motivosRechazoRegla,
        motivosRechazoTipoRegla,
        apelarDecision,
        valorScore,
        tasa,
        montoSolicitado,
        cedulaSolicitante,
        cumpleSinCuota,
        montoSugerido,
        plazoSugerido,
        cumpleAntgLaboral,
        timestamp,
        transactionID,
    } = formData || {};

    const hasResults = clasificacionScore || decisionFinal;
    const hasSchemaErrors = rawErrors && rawErrors.length > 0;
    const showRequiredError = !readonly && !hasResults && (required || hasSchemaErrors);
    const showApelarDecision = decisionFinal === "RECHAZO";
    const showApelarError = showApelarDecision && !readonly && !apelarDecision;

    function handleApelarChange(value) {
        formContext.setFormDataValues({
            "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.apelarDecision": value,
        });
    }

    async function evaluate(e) {
        e.preventDefault();
        if (isLoading) return;

        setIsLoading(true);
        setError("");

        try {
            const { clients, caseLoanInfo } = formObject;
            const response = await ProvenirApi.evaluateCreditCapacity({ clients, caseLoanInfo });
            console.log("response", response);
            const responseSalida = response?.Data?.Provenir?.Salida || {};
            const motivos = responseSalida?.Motivos_Rechazo?.Motivo || {};

            formContext.setFormDataValues({
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.clasificacionScore": responseSalida?.clasificacionScore ?? "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.cumpleCapacidadPago": responseSalida?.cumpleCapacidadPago != null ? String(responseSalida.cumpleCapacidadPago) : "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.cumpleEdadPlazo": responseSalida?.cumpleEdadPlazo != null ? String(responseSalida.cumpleEdadPlazo) : "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.cumpleMora30d": responseSalida?.cumpleMora30d != null ? String(responseSalida.cumpleMora30d) : "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.cumpleMora60d": responseSalida?.cumpleMora60d != null ? String(responseSalida.cumpleMora60d) : "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.cumpleMora90d": responseSalida?.cumpleMora90d != null ? String(responseSalida.cumpleMora90d) : "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.decisionFinal": responseSalida?.decisionFinal ?? "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.motivosRechazoIdentificador": motivos?.Identificador ?? "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.motivosRechazoMensaje": motivos?.mensaje ?? "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.motivosRechazoRegla": motivos?.regla ?? "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.motivosRechazoTipoRegla": motivos?.tipoRegla ?? "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.valorScore": responseSalida?.valorScore ?? "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.tasa": responseSalida?.tasa ?? "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.montoSolicitado": responseSalida?.montoSolicitado ?? "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.cedulaSolicitante": responseSalida?.cedulaSolicitante ?? "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.cumpleSinCuota": responseSalida?.cumpleSinCuota != null ? String(responseSalida.cumpleSinCuota) : "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.montoSugerido": responseSalida?.montoSugerido ?? "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.plazoSugerido": responseSalida?.plazoSugerido ?? "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.cumpleAntgLaboral": responseSalida?.cumpleAntgLaboral != null ? String(responseSalida.cumpleAntgLaboral) : "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.timestamp": responseSalida?.timestamp ?? "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.transactionID": responseSalida?.transactionID ?? "",
            });
        } catch (err) {
            setError(err.message || "Error al evaluar capacidad de crédito.");
        }

        setIsLoading(false);
    }

    return (
        <>
            {error ? (
                <Notification color="danger">
                    <div>{error}</div>
                </Notification>
            ) : null}
            {!readonly ? (
                <FormGroup className="file-field" disabled={readonly || isLoading}>
                    <Button
                        id={idSchema?.decisionFinal?.$id}
                        className="btn btn-secondary"
                        onClick={(e) => evaluate(e)}
                    >
                        {isLoading ? <Loader /> : title}
                    </Button>
                    {showRequiredError ? (
                        <ul className="error-detail bs-callout bs-callout-info">
                            <li className="text-danger">es requerido</li>
                        </ul>
                    ) : null}
                </FormGroup>
            ) : null}
            {hasResults ? (
                <FormGroup>
                    <legend>{title}</legend>
                    <Table hover size="sm">
                        <tbody>
                            <tr><td>Clasificación Score</td><td>{clasificacionScore}</td></tr>
                            <tr><td>Cumple Capacidad de Pago</td><td>{cumpleCapacidadPago}</td></tr>
                            <tr><td>Cumple Edad Plazo</td><td>{cumpleEdadPlazo}</td></tr>
                            <tr><td>Cumple Mora 30d</td><td>{cumpleMora30d}</td></tr>
                            <tr><td>Cumple Mora 60d</td><td>{cumpleMora60d}</td></tr>
                            <tr><td>Cumple Mora 90d</td><td>{cumpleMora90d}</td></tr>
                            <tr><td>Decisión Final</td><td>{decisionFinal}</td></tr>
                            <tr><td>Valor Score</td><td>{valorScore}</td></tr>
                            <tr><td>Tasa</td><td>{tasa}</td></tr>
                            <tr><td>Monto Solicitado</td><td>{montoSolicitado}</td></tr>
                            <tr><td>Cédula Solicitante</td><td>{cedulaSolicitante}</td></tr>
                            <tr><td>Cumple Sin Cuota</td><td>{cumpleSinCuota}</td></tr>
                            <tr><td>Monto Sugerido</td><td>{montoSugerido}</td></tr>
                            <tr><td>Plazo Sugerido</td><td>{plazoSugerido}</td></tr>
                            <tr><td>Cumple Antigüedad Laboral</td><td>{cumpleAntgLaboral}</td></tr>
                            <tr><td>Timestamp</td><td>{timestamp}</td></tr>
                            <tr><td>Transaction ID</td><td>{transactionID}</td></tr>
                            {motivosRechazoIdentificador ? (
                                <>
                                    <tr><td>Motivos Rechazo - Identificador</td><td>{motivosRechazoIdentificador}</td></tr>
                                    <tr><td>Motivos Rechazo - Mensaje</td><td>{motivosRechazoMensaje}</td></tr>
                                    <tr><td>Motivos Rechazo - Regla</td><td>{motivosRechazoRegla}</td></tr>
                                    <tr><td>Motivos Rechazo - Tipo Regla</td><td>{motivosRechazoTipoRegla}</td></tr>
                                </>
                            ) : null}
                            {showApelarDecision ? (
                                <tr>
                                    <td>Apelar la Decisión</td>
                                    <td>
                                        {readonly ? apelarDecision : (
                                            <>
                                                <Input
                                                    type="textarea"
                                                    value={apelarDecision || ""}
                                                    onChange={(e) => handleApelarChange(e.target.value)}
                                                    invalid={showApelarError}
                                                />
                                                {showApelarError ? (
                                                    <ul className="error-detail bs-callout bs-callout-info">
                                                        <li className="text-danger">es requerido</li>
                                                    </ul>
                                                ) : null}
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ) : null}
                        </tbody>
                    </Table>
                </FormGroup>
            ) : null}
        </>
    );
}

export default EvaluateCreditCapacityField;